
import '../styles/my-aeroval.css'

export function initMyAeroval() {
  // redirect to page
  window.location.href = 'https://login.my-aeroval.met.no';
}